var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{staticClass:"culture_title",attrs:{"src":require("@/assets/culture_title.png")}}),_c('div',{staticClass:"culture_img"},[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":require("@/assets/culture_img1.png")}})])])
}]

export { render, staticRenderFns }